import { render, staticRenderFns } from "./LoginMenu.vue?vue&type=template&id=bde8b134&scoped=true&"
import script from "./LoginMenu.vue?vue&type=script&lang=ts&"
export * from "./LoginMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LoginMenu.vue?vue&type=style&index=0&id=bde8b134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde8b134",
  null
  
)

export default component.exports